import { observer } from "mobx-react"
import { Flex, Form, Input, Select, Typography } from "antd"
import { useForm } from "antd/es/form/Form"

import { GlobalCountryCollection } from "@src/app/CountryCollection"
import { urlPattern } from "@src/app/validators"
import { RegistrationFormContacts } from "@src/pages/registration/ui/selfInfoForm/ui/RegistrationFormContacts"
import {
  SignupDetailsRequest,
  SignupDetailsRequestUserTypeEnum,
} from "@src/shared/api/generated"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"
import { useCatchFormErrors } from "@src/shared/form/base_error"
import { useBreakpoint } from "@src/shared/hooks/useBreakpoints"

type Props = {
  isLoading: boolean
  onSubmit: (args: SignupDetailsRequest) => Promise<void>
  userType: string
}
export const RegistrationFormSelfInfo = observer(
  ({ isLoading, onSubmit, userType }: Props) => {
    const [form] = useForm()
    const isRefer = userType === SignupDetailsRequestUserTypeEnum.Referrer
    const c = GlobalCountryCollection()
    const { submit: onSubmitForm } = useCatchFormErrors(form, (values) =>
      submit(values),
    )

    const { smallerThanLg } = useBreakpoint()

    const submit = (v: SignupDetailsRequest) => {
      return onSubmit({
        ...v,
        contacts: v.contacts?.filter((contact) =>
          Boolean(contact && contact.value),
        ),
      })
    }

    return (
      <Form
        form={form}
        id="GENERATED_ID_REGISTRATIONFORMSELFINFO_FORM_VOID_1"
        layout="vertical"
        name="details"
        onFinish={onSubmitForm}
        style={{
          padding: smallerThanLg ? "32px 16px" : 40,
          width: "100%",
        }}
      >
        <Typography.Title
          level={4}
          style={{ margin: "0 0 32px 0", textAlign: "center" }}
        >
          Please Introduce yourself here
        </Typography.Title>
        <Flex gap={16} vertical>
          <Form.Item
            id="GENERATED_ID_REGISTRATIONFORMSELFINFO_TSX_FORM.ITEM_VOID_1"
            label="Your name"
            name={["details", "name"]}
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (value && value.match(/^[\p{L}'][ \p{L}'-]*\p{L}$/u)) {
                    return Promise.resolve()
                  }

                  return Promise.reject(new Error("Please input correct name"))
                },
              },
            ]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>

          <Form.Item
            id="GENERATED_ID_REGISTRATIONFORMSELFINFO_TSX_FORM.ITEM_VOID_2"
            label="Company Name"
            name={["details", "company_name"]}
            rules={[
              { message: "Please input company name", required: !isRefer },
            ]}
          >
            <Input placeholder="Enter company name" />
          </Form.Item>

          {isRefer ? (
            <Form.Item
              id="GENERATED_ID_REGISTRATIONFORMSELFINFO_TSX_FORM.ITEM_VOID_3"
              label="Country"
              name={["details", "country_code_alpha_3"]}
              rules={[
                {
                  message: "Please, input country code",
                  required: true,
                },
              ]}
            >
              <Select
                loading={c.isLoading || isLoading}
                options={c.countriesOptions}
                placeholder="Enter country"
              />
            </Form.Item>
          ) : (
            <Form.Item
              id="GENERATED_ID_REGISTRATIONFORMSELFINFO_TSX_FORM.ITEM_VOID_4"
              label="Corporate Website"
              name={["details", "company_website"]}
            >
              <Input placeholder="https://example.com" />
            </Form.Item>
          )}

          <RegistrationFormContacts form={form} required={isRefer} />
        </Flex>

        <Flex justify="center" style={{ marginTop: 32 }}>
          <SubmitButton
            buttonProps={{
              loading: isLoading,
              size: "middle",
              type: "primary",
            }}
            form={form}
          >
            Sign Up
          </SubmitButton>
        </Flex>
      </Form>
    )
  },
)
